module.exports = __webpack_public_path__ + "img/banner0305_1.d4d4c7ab.jpg";